import api from '@/services/api';

export const PINCODE_RULE = (v) => !v || /^\d{6}$/.test(v) || 'Enter a valid 6-digit pincode';

// Resolves to { city, state, country } or null (invalid/not-found/network
// error) — callers treat auto-fill as a convenience, never block submit on it.
export async function lookupPincode(pincode) {
  if (!/^\d{6}$/.test(pincode)) return null;

  try {
    const { data } = await api.get(`/customers/pincode/${pincode}`);
    return data;
  } catch (err) {
    console.warn('Pincode lookup failed:', err?.response?.status, err?.response?.data?.message || err.message);
    return null;
  }
}
